import "./Body.module.scss";

export const Body = () => {
  return (
    <div className="body">
      <div className="content">
        <div className="logoImg">
          <img src={require(`./../../assets/logo.jpg`)} alt="" />
        </div>
        <div className="info-container">
          <div className="text">Sito in costruzione</div>
          <div className="info-text">Stiamo lavorando duramente per darti la migliore esperienza!</div>
        </div>
      </div>
    </div>
  );
};